var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mobile-navigation",
      class: _vm.isMenuOpen ? "mobile-navigation--is-open" : ""
    },
    [
      _c("navbar-hamburger", {
        ref: "hamburger",
        on: { open: _vm.openMenu, close: _vm.closeMenu }
      }),
      _c(
        "transition",
        {
          attrs: { name: "fade" },
          on: {
            enter: function($event) {
              return _vm.enableLinks()
            },
            leave: function($event) {
              return _vm.disableLinks()
            }
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isMenuOpen,
                  expression: "isMenuOpen"
                }
              ],
              staticClass: "mobile-navigation__nav"
            },
            [
              _c(
                "div",
                { staticClass: "mobile-navigation__nav-header" },
                [
                  _vm.progressLevel > 1
                    ? _c("base-button", {
                        staticClass:
                          "button--icon mobile-navigation__back-button",
                        attrs: { icon: "arrow-left", "icon-size": "20px" },
                        on: { click: _vm.menuRetreat }
                      })
                    : _vm._e(),
                  _vm.progressLevel > 1 && _vm.showLinks
                    ? _c(
                        "h3",
                        { staticClass: "mobile-navigation__menu-heading" },
                        [_vm._v(_vm._s(_vm.activeMenuTitle))]
                      )
                    : _vm._e(),
                  _c("base-button", {
                    staticClass: "button--icon mobile-navigation__close-button",
                    attrs: { icon: "close", "icon-size": "20px" },
                    on: { click: _vm.closeMenu }
                  })
                ],
                1
              ),
              _c(
                "transition-group",
                {
                  staticClass: "mobile-navigation__linklist",
                  attrs: { tag: "ul", name: _vm.menuTransition }
                },
                [
                  _vm._l(_vm.activeMenuItems, function(menuItem, index) {
                    return _vm.showLinks
                      ? _c(
                          "li",
                          {
                            key: _vm.toKebabCase(menuItem.title),
                            staticClass: "mobile-navigation__node"
                          },
                          [
                            menuItem.url && menuItem.url !== "#"
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "mobile-navigation__link",
                                    attrs: { href: menuItem.url }
                                  },
                                  [_vm._v(_vm._s(menuItem.title))]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass: "mobile-navigation__link",
                                    on: {
                                      click: function($event) {
                                        return _vm.menuProgress(menuItem)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(menuItem.title))]
                                ),
                            !menuItem.url
                              ? _c("base-button", {
                                  staticClass:
                                    "button--icon mobile-navigation__node-icon",
                                  attrs: {
                                    icon: "chevron-right",
                                    "icon-size": "14px"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.menuProgress(menuItem)
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  _vm.progressLevel === 2 && _vm.showLinks
                    ? _c(
                        "div",
                        {
                          key: "subnav_tile",
                          staticClass: "mobile-subnav-tiles-wrapper"
                        },
                        [
                          _c("mobile-subnav-tiles", {
                            attrs: { menuItem: _vm.activeMenu }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              ),
              _vm.progressLevel === 1
                ? _c("div", { staticClass: "mobile-navigation__footer" }, [
                    _c(
                      "a",
                      {
                        staticClass: "mobile-navigation__account-link",
                        attrs: { href: _vm.userLink }
                      },
                      [
                        _c("icon", { attrs: { name: "circle", size: "15px" } }),
                        _c("span", [_vm._v(_vm._s(_vm.userLabel))])
                      ],
                      1
                    ),
                    _c("div", {
                      staticClass: "mobile-navigation__contact-info",
                      domProps: { innerHTML: _vm._s(_vm.contactInfoArea) }
                    })
                  ])
                : _vm._e()
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }